import { Component, ElementRef, HostBinding, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { first, timer } from 'rxjs';

@Component({
    selector: 'urban-loading-panel',
    templateUrl: './loading-panel.component.html',
    styleUrl: './loading-panel.component.scss',
    standalone: false
})
export class LoadingPanelComponent implements OnChanges {
  @HostBinding('style.--content-height') public contentHeight: string = '200px';

  @ViewChild('content') private contentElement: ElementRef;

  @Input() public loading: boolean = false;
  @Input() public hasTopMargin: boolean = false;
  @Input() public hideMargin: boolean = true;

  public loaded: boolean = false;
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.loading && changes.loading.currentValue !== changes.loading.previousValue && 
      this.loading !== null && this.loading !== undefined
    ) {
      if (this.contentElement) {
        this.contentHeight = `${this.contentElement.nativeElement.offsetHeight}px`;
      }
      if (this.loading === false) {
        this.loaded = true;
        timer(1000).pipe(first()).subscribe(() => {
          this.loaded = false;
        })
      }
    }
  }
}
